"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeTerminal = decodeTerminal;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const decode_prop_block_1 = require("./decode-prop-block");
function decodeTerminal(node, path, warnings) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for terminal, got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const c = node.children;
    if (c.length !== 15 && c.length !== 16) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `terminal has ${c.length} children, expected 15 or 16`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const subReference = readPrefixedAtom(c[3], '19:');
    const positionContainer = isContainer(c[7]) ? c[7] : null;
    const netHash = readPrefixedAtom(c[9], '5:');
    const props = (0, decode_prop_block_1.decodePropBlock)(c[14], `${path}/props`, warnings);
    return {
        kind: 'terminal',
        subReference,
        positionContainer,
        netHash,
        props,
        raw: node,
    };
}
function isContainer(node) {
    return node.type === 'container' || node.type === 'econtainer';
}
function readPrefixedAtom(node, prefix) {
    if (node.type !== 'atom') {
        return null;
    }
    const content = node.content.trim();
    if (!content.startsWith(prefix)) {
        return null;
    }
    return content.slice(prefix.length);
}
//# sourceMappingURL=decode-tc13-terminal.js.map